'use strict';

/**
 * @ngdoc function
 * @name cloudBillingLegacyFrontend.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the cloudBillingLegacyFrontend
 */
angular.module('cloudBillingLegacyFrontend').controller('CcAddGcpContractDashboardCtrl', function ($scope, $stateParams) {
  $scope.teamid = $stateParams.teamid;
  $scope.cid= $stateParams.cid;
});
